import React from "react";

// Akaydın Döviz – Corporate Logo Mark
// PDF referansına göre tasarlandı: Stilize altın "A" harfi + finansal ikonlar
// (yükseliş oku, çubuk grafik, istiflenmiş paralar)

export function LogoMark({ size = 44, className = "" }) {
  const gold = "#C5A059";
  const goldDark = "#A88240";
  const navy = "#0F172A";
  const gray = "#475569";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Akaydın Döviz"
    >
      {/* Büyük altın 'A' çerçevesi */}
      <path
        d="M 12 68 L 32 12 L 48 12 L 68 68 L 58 68 L 52 52 L 28 52 L 22 68 Z"
        stroke={gold}
        strokeWidth="2.2"
        strokeLinejoin="round"
        fill="none"
      />
      {/* A içindeki yatay altın çizgi */}
      <path
        d="M 32 44 L 48 44"
        stroke={gold}
        strokeWidth="2"
        strokeLinecap="round"
      />

      {/* Çubuk grafik - navy bars, artan yükseklikte */}
      <rect x="30" y="38" width="3.5" height="12" fill={navy} rx="0.5" />
      <rect x="35" y="32" width="3.5" height="18" fill={navy} rx="0.5" />
      <rect x="40" y="26" width="3.5" height="24" fill={gray} rx="0.5" />

      {/* Yükseliş oku - altın, sol taraftan çıkıp yukarı */}
      <path
        d="M 44 32 L 52 20"
        stroke={goldDark}
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <path
        d="M 52 20 L 47 20 M 52 20 L 52 25"
        stroke={goldDark}
        strokeWidth="2.2"
        strokeLinecap="round"
      />

      {/* İstiflenmiş paralar - sağ alt köşede */}
      <ellipse cx="56" cy="48" rx="4" ry="1.4" fill={gold} />
      <ellipse cx="56" cy="45" rx="4" ry="1.4" fill={goldDark} />
      <ellipse cx="56" cy="42" rx="4" ry="1.4" fill={gold} />
    </svg>
  );
}

// Sadece wordmark
export function LogoFull({ height = 40, theme = "dark", className = "" }) {
  const textColor = theme === "dark" ? "#0F172A" : "#FFFFFF";
  return (
    <div className={`flex items-center gap-3 ${className}`} aria-label="Akaydın Döviz">
      <LogoMark size={height} />
      <div
        className="font-display font-bold tracking-tight leading-none"
        style={{ color: textColor, fontSize: height * 0.5 }}
      >
        Akaydın <span style={{ color: "#C5A059" }}>Döviz</span>
      </div>
    </div>
  );
}

export default LogoMark;
